import React from 'react';

import { Button } from 'components/ui/button';

type SearchAreaProps = {
  searchArea: () => void;
}

export default function SearchThisArea({ searchArea }: SearchAreaProps) {
  return (
    <div className="bg-white rounded p-1"
      style={{
        position: 'absolute',
        bottom: '20px',
        right: '35%',
        zIndex: 1000,
      }}
    >
      <Button label="Search This Area" variant="outline" onClick={searchArea} />
    </div>
  );
}
